module.exports = __webpack_public_path__ + "img/banker-green-page_1248.b546aa68.png";